import React from 'react'

export default function Cursor() {
  return (<>
    <div id='cursor'></div>
    <div id='cursor-blur'></div>
    </>
  )
}
